import { render, staticRenderFns } from "./NewsletterForm.vue?vue&type=template&id=23ce54b3&scoped=true&"
import script from "./NewsletterForm.vue?vue&type=script&lang=js&"
export * from "./NewsletterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ce54b3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23ce54b3')) {
      api.createRecord('23ce54b3', component.options)
    } else {
      api.reload('23ce54b3', component.options)
    }
    module.hot.accept("./NewsletterForm.vue?vue&type=template&id=23ce54b3&scoped=true&", function () {
      api.rerender('23ce54b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/NewsletterForm.vue"
export default component.exports